import { Form, Row } from 'react-bootstrap'

import useFormStore from '../stores/useFormStore'
import emailService from '../services/EmailService'
import constructorService from '../services/ConstructorService'

const FormComponent = (component) => {

  const formData = useFormStore(state => state.formData)
  const formErrors = useFormStore(state => state.formErrors)
  const resetForm = useFormStore(state => state.resetForm)
  const { setError } = useFormStore()

  const handleSubmit = async (event) => {
    try {
      event.preventDefault()

      const fieldNames = Object.keys(formData);

      fieldNames.forEach(fieldName => {
        if (!formData[fieldName] || formData[fieldName].trim() === "") {
          setError(fieldName, 'Campo obrigatório')
        } else {
          setError(fieldName, null)
        }
      });

      console.log(formErrors)
      if (formErrors) {
        console.log('Formulário com erros, não enviar')
        return
      }

      console.log('Enviando dados:', formData)

      resetForm()

    } catch (error) {
      console.error('Erro ao enviar o formulário:', error)
    }
  }

  return (
    <Form noValidate onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
      <Row className='form-contact'>
        {Object.values(component.elements.content).map((content) => (
          constructorService.createElement(content)
        ))}
      </Row>
    </Form>
  )
}

export default FormComponent